import EmbeddedFormModal from "../../../../popUpForms/formModals/embeddedFormModal";
import EmbeddedScorecardFormSubscribe from "../../../../popUpForms/embeddedScorecardFormSubscribe";

const CardScorecardSubscribeForUpdates = ({
  onSuccess,
  onError,
  hoveredTab,
  onTabHover,
  onTabLeave,
}) => {
  const id = "scorecard-subscribe-long";
  const titleColor = "var(--cornflower-blue)";

  return (
    <div
      id="scorecard-subscribe-long"
      onMouseEnter={() => onTabHover("scorecard-subscribe-long")}
      onMouseLeave={() => onTabLeave()}
      className="cwpc home-card-box"
      style={{
        border: hoveredTab === id ? `1px solid ${titleColor}` : ``,
      }}
    >
      <div className="card-content">
        <div className="card-title">
          {" "}
          <h3 className="text-cornflower-blue">Subscribe for Updates!</h3>
        </div>
        <figcaption>
          Providing your contact information enables us to share best practices,
          communicate updates, and network with our global wildfire prevention
          community.
        </figcaption>
        <br />
        <EmbeddedFormModal>
          <EmbeddedScorecardFormSubscribe />
        </EmbeddedFormModal>
      </div>
    </div>
  );
};

export default CardScorecardSubscribeForUpdates;
